module.exports = __webpack_public_path__ + "images/f8050f6007950864094a690dd2ac80e7171b72bda06a6742e3e4be95c235b295.svg";